<template>
  <div class="input-wrapper text-sm">
    <slot></slot>
    <div v-if="dirty" class="indicator text-2xl">
      <span v-if="valid">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
      </span>
      <span v-else>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
// acts as a wrapper for input fields, adding a check- or crossmark
// to the end of the input field to give an indicator for the validation
export default {
  name: 'ValidationIndicator',
  props: {
    dirty: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    }
  }
}
</script>
